import request from '@/router/axios';

// 查询设备配置列表     pageNum   pageSize      1   2
export const getEquipConfigList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/getEquipConfigList',
    method: 'get',
    params: data
  })
};

// 设备类型列表          无        1   2
export const equipTypeList = () => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/equipTypeList',
    method: 'get',
  })
};

// 查询设备选择列表-树状  infoId   1    2
export const equipCheckTreeList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/equipCheckTreeList',
    method: 'get',
    params: data
  })
};

// 查询设备配置详情     infoId    1
export const getEquipConfigDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/getEquipConfigDetail',
    method: 'get',
    params: data
  })
};

// 查询项目下点表树-选定设备    projectId   equipId
export const searchFieldTreeByProjectAndEquipId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/searchFieldTreeByProjectAndEquipId',
    method: 'get',
    params: data
  })
};

// 保存设备配置   1-select页面报错504
export const saveEquipConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/saveEquipConfig',
    method: 'post',
    data: data
  })
};

// 设备配置生效
export const takeEffectEquipConfig = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/takeEffectEquipConfig',
    method: 'post',
    data: data
  })
};

//查询项目并网点列表
export const searchProjectGridList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectGrid/searchProjectGridList',
    method: 'get',
    params: data
  })
};

// 自动匹配模板设备与典型参数的数据点
export const autoMatchDataPoints = (data) => {
  return request({
    url: '/svolt-ess-boss-service/projectEquipConfigInfo/autoMatchDataPoints',
    method: 'post',
    data: data
  })
};

export default {
  getEquipConfigList,
  equipTypeList,
  getEquipConfigDetail,
  searchFieldTreeByProjectAndEquipId,
  equipCheckTreeList,
  saveEquipConfig,
  takeEffectEquipConfig,
  searchProjectGridList,
  autoMatchDataPoints
}



// WEBPACK FOOTER //
// ./src/api/equipmentConfig.js